<div class="card-body position-relative overflow-hidden">
  <div class="font-size-36 font-weight-bold text-dark mb-n2">$256</div>
  <div class="text-uppercase">income</div>
  <div class="chartContainer">
    <x-chartist [data]="chartData" [type]="chartOptions.type" [options]="chartOptions.options"
      [responsiveOptions]="chartOptions.responsiveOptions" [events]="chartOptions.events" class="ct-hidden-points">
    </x-chartist>
  </div>
</div>